import type { ComponentType, SVGProps } from 'react';
import type { MaintenanceQuoteConsentStatus } from './types/quote-centric';
import { IconClose, IconCheck2, IconPending } from '@belong/icons';

export const MAINTENANCE_LABEL_CLASS_NAME =
  'inline-flex h-auto items-center rounded-small py-2xs leading-[normal]';

export const QUOTE_APPROVAL_STATUS_STYLES: Record<
  Exclude<MaintenanceQuoteConsentStatus, 'NotRequired'>,
  {
    label: (party?: string) => string;
    className: string;
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
  }
> = {
  Approved: {
    label: (p) => (p ? `Approved by ${p}` : 'Approved'),
    className: 'text-green',
    Icon: IconCheck2,
  },
  Rejected: {
    label: (p) => (p ? `Rejected by ${p}` : 'Rejected'),
    className: 'text-dark-gray',
    Icon: IconClose,
  },
  Required: {
    label: (p) => (p ? `Pending Approval by ${p}` : 'Pending Approval'),
    className: 'text-red',
    Icon: IconPending,
  },
};

export const URL_QUERY_PARAMS = {
  TOAST_VISIBLE: 'toast-visible',
  SUCCESS: 'success',
  CREATION: 'creation',
  UPDATE: 'update',
  TURN_OFF: 'turn-off',
  UPDATE_FREQUENCY: 'update-frequency',
  NEXT_ON: 'next-on',
  CANCEL: 'cancel',
  TASK: 'task',
  UNIT_ID: 'unit-id',
  OUTCOME: 'outcome',
};

export const API_ERRORS = {
  APPOINTMENT_TOO_SOON: 'APPOINTMENT_TOO_SOON',
};

export const ICON_SLOT_CLASS_NAME =
  'pointer-events-none flex h-md w-md shrink-0 items-center justify-center';
